<script>
import {HorizontalBar, mixins} from "vue-chartjs";
// const { reactiveProp } = mixins UNUSABLE because of non-reactive chartjs-data-labels

export default {
  extends: HorizontalBar,

  name: "GmbStatisticsHorizontalBarChart",

  props: {
    chartData: {
      default: () => {
      },
      required: true,
      type: Object,
    },
    options: {
      default: () => {
      },
      required: true,
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {},

  watch: {
    chartData: function () {
      this.renderChart(this.chartData, this.options);
    }, // FULL RE-RENDER
  },

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
